import React, { useEffect, useState } from 'react';
import { TablePagination } from '@leverege/molten/data-viewers';
import { Paginator } from '@leverege/molten/screens';
import { Popup, Selector } from '@leverege/ui-elements';
import { Attributes } from '@leverege/ui-attributes';
import FotaAttrValueOptionsFactory from "../fotaAttrValueOptions/FotaAttrValueOptionsFactory.js";
import FotaAttrValueOptionFactory from "../fotaAttrValueOptions/FotaAttrValueOptionFactory.js";
import S from './FotaItemSelector.css';
function FotaItemSelector(props) {
  const {
    attr,
    onChange,
    data,
    context,
    getQuery
  } = props;
  const {
    delegate,
    relationship
  } = context;
  const value = attr.get(data);
  const [options, setOptions] = useState({});
  const [option, setOption] = useState(null);
  const [pagination, setPagination] = useState({
    perPage: 100,
    page: 0
  });
  const [paginator] = useState(new Paginator({
    onPageChange: ({
      perPage,
      page
    }) => {
      setPagination({
        perPage,
        page
      });
    }
  }));
  paginator.setData({
    ...options,
    ...pagination,
    count: options?.total
  });
  useEffect(() => {
    FotaAttrValueOptionsFactory.create(attr?.source?.targetType, {
      attr,
      delegate,
      relationship,
      limit: paginator.perPage,
      offset: paginator.startIndex,
      query: getQuery?.(data, context)
    }).then(options => setOptions(options));
  }, [pagination]);
  useEffect(() => {
    if (value && option?.id !== value) {
      FotaAttrValueOptionFactory.create(attr?.source?.targetType, {
        id: value
      }).then(option => setOption(option));
    }
  }, [value]);
  const title = Attributes.get('name', attr?.source?.targetType, option);
  if (paginator.pages <= 1) {
    return /*#__PURE__*/React.createElement(Selector, {
      nameKey: "name",
      valueKey: "value",
      value: option?.id,
      values: options?.items?.map(i => ({
        name: Attributes.get('name', attr?.source?.targetType, i, {
          getImagineName: true
        }),
        value: i.id
      })),
      onChange: onChange,
      eventData: {
        attribute: attr
      }
    });
  }

  // TODO : this looks bad
  return /*#__PURE__*/React.createElement(Popup, {
    toggleVariant: "selector",
    title: title || 'none'
  }, options?.items?.map(i => /*#__PURE__*/React.createElement(Popup.Item, {
    onClick: ({
      data
    }) => {
      setOption(data);
      onChange({
        data: {
          attribute: attr
        },
        value: data.id
      });
    },
    key: i.id,
    eventData: i
  }, Attributes.get('name', attr?.source?.targetType, i, {
    getImagineName: true
  }))),
  // only show pagination if we need to
  paginator.pages > 1 ? /*#__PURE__*/React.createElement(TablePagination, {
    footerClassName: S.sticky,
    paginator: paginator
  }) : null);
}
const type = 'fotaItemSelector';
export default {
  type,
  editor: FotaItemSelector
};